import isEmpty from 'lodash/isEmpty'
import { Customer } from '@typesApp/Customer'
import { normalizeCustomerNumber } from './isCustomerNumberValid'

export const sanitizeCustomer = (customer: Customer): Customer => {
  const { id, firstName, lastName, email, phoneNumber, legacyId } = customer ?? {}

  const sanitizedCustomer: Customer = {
    id: normalizeCustomerNumber(id),
  }

  if (!isEmpty(email?.trim())) sanitizedCustomer.email = email?.trim()
  if (!isEmpty(firstName?.trim())) sanitizedCustomer.firstName = firstName?.trim()?.replaceAll(/\s+/g, ' ')
  if (!isEmpty(lastName?.trim())) sanitizedCustomer.lastName = lastName?.trim()?.replaceAll(/\s+/g, ' ')
  if (!isEmpty(phoneNumber?.trim())) sanitizedCustomer.phoneNumber = phoneNumber?.trim()
  if (!isEmpty(legacyId?.trim())) sanitizedCustomer.legacyId = legacyId?.trim()

  // some brands send us combined firstName + lastName in firstName field
  if (!sanitizedCustomer.lastName && sanitizedCustomer.firstName) {
    const nameParts = splitName(sanitizedCustomer.firstName)
    if (nameParts) {
      sanitizedCustomer.firstName = nameParts.firstName
      sanitizedCustomer.lastName = nameParts.lastName
    }
  }

  return sanitizedCustomer
}

type NameParts = {
  firstName: string
  lastName: string | undefined
}

const splitName = (combinedName: string): NameParts | undefined => {
  const tokens = combinedName.trim().split(/\s+/).filter(Boolean)

  if (tokens.length < 2) return undefined

  const lastName = tokens.pop()
  const firstName = tokens.join(' ')

  return {
    firstName,
    lastName,
  }
}
